import { useStore } from "src/stores/Store";
import { lg, md, sm } from "src/styles/utility";
import tw from "src/utils/tw";

interface Props {
  className?: string;
  children?: any;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  additionalOffset?: number;
}

export default function StickyHeader(props: Props) {
  const store = useStore();
  let top = 49;

  if (store.user?.isSalesOrAbove) {
    top += 30;
  }

  if (props.additionalOffset) {
    top += props.additionalOffset;
  }

  return (
    <div
      className={tw(
        "relative",
        // "sm:z-10",
        props.sm && "sm:sticky",
        props.md && "md:sticky",
        props.lg && "lg:sticky",
        props.className
      )}
      css={[
        props.sm && {
          [`@media (${sm})`]: {
            top,
          },
        },
        props.md && {
          [`@media (${md})`]: {
            top,
          },
        },
        props.lg && {
          [`@media (${lg})`]: {
            top,
          },
        },
      ]}
    >
      {props.children}
    </div>
  );
}
